<template>
   <div>
      <div class="mt-4">
         <span class="mr-4">
            <router-link
               :to="`/document/${documentId}`"
               class="ln-primary"
               aria-roledescription="Nuoroda"
            >
               <font-awesome-icon icon="arrow-left" class="ln-primary mr-2" aria-hidden="true" />
               Atgal į dokumentą
            </router-link>
         </span>
      </div>
   </div>
</template>

<script>
export default {
   name: 'reference-header',
   props: {
      documentId: Number,
   },
};
</script>

<style lang="scss" scoped>
</style>